import CaptionComponent from './components/CaptionComponent';
import ClipComponent from './components/ClipComponent';
import DivComponent from './components/DivComponent';
import ImageComponent from './components/ImageComponent';
import './components/ImageUpload';
import SVGComponent from './components/SVGComponent';
import TextComponent from './components/TextComponent';
/**
 * Think of this as a component factory.
 *
 * Each object consists of a component prototype and a test function.
 * All elements are passed t
 */
export const componentDefaults = [
    {
        component: SVGComponent,
        name: 'SVGComponent',
        test: (element) => {
            return element.classList.contains('shapeOuter');
        }
    },
    {
        component: TextComponent,
        name: 'TextComponent',
        test: (element) => {
            return element.classList.contains('userTextClass') && !(element.getAttribute('data-amelement') === 'caption');
        }
    },
    {
        component: DivComponent,
        name: 'DivComponent',
        test: (element) => {
            return element.classList.contains('userDivClass');
        }
    },
    {
        component: ClipComponent,
        name: 'ClipComponent',
        test: (element) => {
            return element.getAttribute('data-amelement') === 'sermonclip';
        }
    },
    // {
    //   component: ImageUpload,
    //   name: 'ImageUpload',
    //   test: (element: Element) => {
    //     return element.getAttribute('data-amelement') === 'stamp';
    //   },
    // },
    {
        component: ImageComponent,
        name: 'ImageComponent',
        test: (element) => {
            return element.classList.contains('stampElem');
        }
    },
    {
        component: CaptionComponent,
        name: 'CaptionComponent',
        test: (element) => {
            return element.getAttribute('data-amelement') === 'caption';
        }
    }
];
